<div class="jour-calendrier" [ngClass]="determinerClasseSelonNombreElementEtDuree()">
	@for (evenementCalendrier of evenementsCalendriers(); track evenementCalendrier) {
		@if (!masquerReservation() || evenementCalendrier.getType() !== TypeEvenementCalendrier.RESERVATION) {
			<div class="card-element"
				 [ngClass]="determinerClasseSelonStatutDureeTypeEvenement(evenementCalendrier)"
				 (click)="notifierOuvertureDetailModale(evenementCalendrier)">
				<i class="pi" [ngClass]="determinerClasseIconeEvenement(evenementCalendrier)"></i>
				<div class="label-information">{{ labelEvenementcalendrier(evenementCalendrier) }}</div>
			</div>
		}
	}

	@if (plageSelectionnablePourNouvelEvenement()) {
		<div class="plage-selectionnable" [ngClass]="renseignerClassePlageDisponibleSelectionneEtHauteur()" (click)="selectionnerDeselectionnerPlageDisponible()">
			<i class="pi pi-calendar-plus" [ngClass]="renseignerClassePlageDisponibleSelectionneEtHauteur()"></i>
		</div>
	}
</div>
